import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PlatformType } from '@root/config';
import { HostexModel, HouseModel } from './base-house-relation/base-house-relation.component';
import { CacheService } from '@delon/cache';
export interface DragEvent {
  dragData: any;
  nativeEvent: any;
}

export enum HouseType {
  Multi = 'multi', // 房型
  Single = 'single', // 房间
  OTA = 'ota', // 其实就是房型。。
}

export enum AirbnbLinkType {
  Official = 'official',
  UnOfficial = 'unOfficial',
}

@Injectable({
  providedIn: 'root',
})
export class RelationService {
  dragThirdpartyHouseTypeRaw$ = new Subject<any>();
  addCardToHostexHouseRaw$ = new Subject<{ card: any; hostex: any }>();
  addCardToHostexHouseTypeRaw$ = new Subject<{ card: any; hostex: any }>();
  addCardToThirdpartyHousesRaw$ = new Subject<{
    card: any;
  }>();
  // removeCardFromHostexHouseRaw$ = new Subject<{ card: any; hostex: any }>();
  // removeCardFromHostexHouseTypeRaw$ = new Subject<{ card: any; hostex: any }>();
  removeCardFromThirdpartyHousesRaw$ = new Subject<{ card: any }>();
  // removeCardFromHouseRaw$ = new Subject<{ card: any }>();
  removeCardFromHouseTypeRaw$ = new Subject<{ card: any }>();

  modifyRaw$ = new Subject<boolean>();

  //#region v4
  leftPanelSelectItem$ = new Subject<HostexModel>();
  typeTabChange$ = new Subject<number>();
  channelTabChange$ = new Subject<number>();
  removeCardFromHostexRaw$ = new Subject<{ card: HouseModel; hostex: HostexModel }>();
  addCardToHostexRaw$ = new Subject<{ card: HouseModel; hostex: HostexModel }>();
  addCardToHousesRaw$ = new Subject<{ card: HouseModel; hostex: HostexModel }>();
  removeCardFromHousesRaw$ = new Subject<{ card: HouseModel; hostex: HostexModel }>();
  // removeCardFromHostexHouseTypeRaw$ = new Subject<{ card: HouseModel; hostex: HostexModel }>();
  //#endregion
  constructor(private cache: CacheService) {}

  //#region v4
  activeChannelTab(index: number) {
    this.channelTabChange$.next(index);
  }

  activeTypeTab(index: number) {
    this.typeTabChange$.next(index);
  }

  selectHostexItemNotify(item) {
    this.leftPanelSelectItem$.next(item);
  }

  removeCardFromHostex(card, hostex) {
    this.removeCardFromHostexRaw$.next({ card, hostex });
  }

  addCardToHostex(card, hostex) {
    this.addCardToHostexRaw$.next({ card, hostex });
  }

  removeCardFromHouses(card, hostex) {
    this.removeCardFromHousesRaw$.next({ card, hostex });
  }

  addCardToHouses(card, hostex) {
    this.addCardToHousesRaw$.next({ card, hostex });
  }

  //#endregion

  addCardToHostexHouse(card, hostex) {
    this.modify(true);
    this.addCardToHostexHouseRaw$.next({ card, hostex });
  }

  addCardToHostexHouseType(card, hostex) {
    this.modify(true);
    this.addCardToHostexHouseTypeRaw$.next({ card, hostex });
  }

  addCardToThirdpartyHouses(card) {
    this.modify(true);
    this.addCardToThirdpartyHousesRaw$.next({ card });
  }

  removeCardFromHostexHouse(card, hostex) {
    this.modify(true);
    // this.removeCardFromHostexHouseRaw$.next({ card, hostex });
  }

  removeCardFromHostexHouseType(card, hostex) {
    this.modify(true);
    // this.removeCardFromHostexHouseTypeRaw$.next({ card, hostex });
  }

  removeCardFromThirdpartyHouses(card) {
    this.modify(true);
    this.removeCardFromThirdpartyHousesRaw$.next({ card });
  }

  removeCardFromHouse(card) {
    this.modify(true);
    // this.removeCardFromHouseRaw$.next({ card });
  }
  removeCardFromHouseType(card) {
    this.modify(true);
    this.removeCardFromHouseTypeRaw$.next({ card });
  }

  modify(isModify: boolean) {
    this.modifyRaw$.next(isModify);
  }

  isAirbnb(thirdparty) {
    return +thirdparty === PlatformType.Airbnb;
  }

  isCtrip(thirdparty) {
    return +thirdparty === PlatformType.Ctrip;
  }

  isFliggy(thirdparty) {
    return +thirdparty === PlatformType.Fliggy;
  }

  isMeituan(thirdparty) {
    return +thirdparty === PlatformType.MeiTuanJiuDian;
  }

  isOTA(thirdparty) {
    return this.isCtrip(thirdparty) || this.isFliggy(thirdparty) || this.isMeituan(thirdparty);
  }

  shouldDisplayLinkRtNote() {
    return !this.cache.getNone('hostex_channel_link_rt_note_displayed');
  }

  hideLinkRtNote() {
    this.cache.set('hostex_channel_link_rt_note_displayed', true);
  }
}
